module.exports = __webpack_public_path__ + "static/media/placeholder_project.50572c73.webp";